import { memo } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { LoadingPlaceholder } from "../Loaders/LoadingPlaceholder";

export enum LogoTypes {
  // Extra Small Sizes
  XXS = "extraExtraSmall",
  XS = "extraSmall",
  SM = "small",

  // Combined Sizes
  SX = "largeSmall",

  // Medium Sizes
  MS = "mediumSmall",
  MD = "medium",
  ML = "mediumLarge",

  // Large Sizes
  LG = "large",
  XL = "extraLarge",
  XXL = "extraExtraLarge",
}

const logoTypes = {
  [LogoTypes.LG]: {
    height: "90px",
    minWidth: "90px",
    width: "90px",
  },
  [LogoTypes.MD]: {
    height: "48px",
    minWidth: "48px",
    width: "48px",
  },
  [LogoTypes.ML]: {
    height: "60px",
    minWidth: "60px",
    width: "60px",
  },
  [LogoTypes.MS]: {
    height: "40px",
    minWidth: "40px",
    width: "40px",
  },
  [LogoTypes.SM]: {
    height: "32px",
    minWidth: "32px",
    width: "32px",
  },
  [LogoTypes.SX]: {
    height: "36px",
    minWidth: "36px",
    width: "36px",
  },
  [LogoTypes.XL]: {
    height: "110px",
    minWidth: "110px",
    width: "110px",
  },
  [LogoTypes.XS]: {
    height: "24px",
    minWidth: "24px",
    width: "24px",
  },
  [LogoTypes.XXL]: {
    height: "140px",
    minWidth: "140px",
    width: "140px",
  },
  [LogoTypes.XXS]: {
    height: "18px",
    minWidth: "18px",
    width: "18px",
  },
};

type Props = {
  alt?: string;
  classNames?: string;
  image?: string;
  type: LogoTypes;
};

export const Logo = memo(({ alt, classNames, image, type }: Props) =>
  isTruthy(image) ? (
    <img
      alt={alt}
      className={cnTwMerge(
        "overflow-hidden rounded-companyBorderRadius",
        classNames,
      )}
      src={image}
      style={logoTypes[type]}
    />
  ) : (
    <div style={logoTypes[type]}>
      <div style={logoTypes[type]}>
        <LoadingPlaceholder />
      </div>
    </div>
  ),
);
